import { render, staticRenderFns } from "./PopoverMenu.vue?vue&type=template&id=737a873a&scoped=true&"
import script from "./PopoverMenu.vue?vue&type=script&lang=ts&"
export * from "./PopoverMenu.vue?vue&type=script&lang=ts&"
import style0 from "./PopoverMenu.vue?vue&type=style&index=0&id=737a873a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "737a873a",
  null
  
)

export default component.exports